import { COUNTRY_CODE } from "../config";

export const COUNTRY_OPTIONS = [
    {
        value: COUNTRY_CODE.VN,
        label: 'Viet Nam'
    },
    {
        value: COUNTRY_CODE.IN,
        label: "India"
    },
    {
        value: COUNTRY_CODE.JP,
        label: "Japan"
    },
    {
        value: COUNTRY_CODE.ID,
        label: "Indonesia"
    },
    {
        value: COUNTRY_CODE.KH,
        label: "Cambodia"
    },
]